export default {
  courseOutlineUnit: {
    id: '',
    courseOutline: null,
    seq: null,
    nameLocal: null,
    nameEng: null,
    descriptionLocal: null,
    descriptionEng: null,
    preTestExpectScore: null,
    postTestExpectScore: null,
    unitAgenda: null,
    unitObjective: null,
    unitReference: null,
  },
  courseOutlineUnits: [],
  processing: false,
  error: null,
  success: null,
}



